export function sessionPresent() {
  return document.cookie
    .split(";")
    .some((cookie) => cookie.trim() === "session_present=1")
}
